<a [routerLink]="['/allgear']">Lånebanken</a>